<div class="radioButtonDs__cont radioButtonDs__cont--{{align}}" (click)="checkEvent()">
  <div class="radioButtonDs__cont__col">
    <div class="radioButtonDs__cont__radio-input radioButtonDs__cont__radio-input--{{align}}">
      <input
        type="radio"
        aria-label="radioButtonDs--input"
        class="radio-input radio-failed-{{failedClass}}"
        [class.radio-disabled]="isDisabled"
        [checked]="checked"
        [disabled]="isDisabled">
    </div>
    <ng-container *ngIf="alignIsLeft">
      <ng-container *ngTemplateOutlet="radioButtonData"></ng-container>
    </ng-container>
  </div>
  <div class="radioButtonDs__cont__col">
    <ng-container *ngIf="alignIsRight">
      <ng-container *ngTemplateOutlet="radioButtonData"></ng-container>
    </ng-container>
    <ng-container *ngTemplateOutlet="radioButtonCounter"></ng-container>
  </div>
</div>

<ng-template #radioButtonData>
  <div class="radioButtonDs__cont__radio-data">
    <ng-container *ngTemplateOutlet="imageOrIcon"></ng-container>
    <ng-container *ngIf="!isTitlesEmpty">
      <div class="radioButtonDs__cont__radio-data__titles">
        <ng-container *ngIf="title">
          <div class="radioButtonDs__cont__radio-data__titles__title">
            <app-ds-typography
              [text]="title.Label"
              [color]="fontColor(title, false)"
              [size]="fontSize(title)"
              [fontFamily]="fontFamily(title)">
            </app-ds-typography>
          </div>
        </ng-container>
        <ng-container *ngFor="let subtitle of subtitles">
          <div class="radioButtonDs__cont__radio-data__titles__subtitle">
            <app-ds-typography
              [text]="subtitle.Label"
              [color]="fontColor(subtitle, true)"
              [size]="fontSize(subtitle)"
              [fontFamily]="fontFamily(subtitle)">
            </app-ds-typography>
            <ng-container *ngIf="subtitle.Icon">
              <app-ds-icon
                [size]="14"
                [color]="iconColor(subtitle, true)"
                [icon]="subtitle.Icon">
              </app-ds-icon>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #radioButtonCounter>
  <app-ds-data
    [data]="counter"
    [fontSize]="fontSize()"
    [isDisabled]="isDisabled">
  </app-ds-data>
</ng-template>

<ng-template #imageOrIcon>
  <ng-container *ngIf="icon; else imgTemplate">
    <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
  </ng-container>
</ng-template>

<ng-template #imgTemplate>
  <ng-container *ngIf="image">
    <div class="radioButtonDs__cont__radio-data__image" [class.disabled]="isDisabled">
      <app-ds-image
        [size]="imageSize"
        [src]="image"
        [objectFit]="'contain'"
        [alt]="image">
      </app-ds-image>
    </div>
  </ng-container>
</ng-template>

<ng-template #iconTemplate>
  <div class="radioButtonDs__cont__radio-data__icon">
    <app-ds-icon
      [icon]="icon"
      [size]="22"
      [color]="iconFillColor">
    </app-ds-icon>
  </div>
</ng-template>